import { render } from "./DockViewPage.vue?vue&type=template&id=7eb41b34"
const script = {}

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__